<template>
    <button ref="switchRef" class="switch" @click="toggleSwitch" @focus="onFocus" @blur="onBlur" @focusout="onBlur">
        <div 
            v-for="option in props.options"
            :key="option.name"
            class="switch-option"
            :class="{'is-active': option.value === props.modelValue}"
        >
            {{ option.name }}
        </div>
    </button>
</template>
<script lang="ts" setup>
import { ref, type Ref, type PropType, inject, onMounted } from "vue";
import type { ISwitch, FocusOnSwitch } from "./types";

const emit = defineEmits(['update:modelValue'])
const props = defineProps({
    options: {
        type: Array as PropType<ISwitch[]>,
        required: true,
        validator(value) {
            return Array.isArray(value) && value.length === 2;
        }
    },
    modelValue: {
        type: Boolean,
        required: true,
        default: false
    }
});
const { $navigator } = useNuxtApp();
const switchRef = ref(null);

const isRegKeyListeners: Ref<boolean> = ref(false); 
const toggleSwitch = (): void => {
    emit('update:modelValue', !props.modelValue);
}
const switchToRightOption = (): void => {
    emit('update:modelValue', props.options[props.options.length - 1].value);
}
const switchToLeftOption = (): void => {
    emit('update:modelValue', props.options[0].value);
}
const registerKeyListeners = (): void => {
    $navigator.on("keypress:right", switchToRightOption);
    $navigator.on("keypress:left", switchToLeftOption);
    isRegKeyListeners.value = true;
}
const unregisterKeyListeners = (): void => {
    $navigator.off("keypress:right", switchToRightOption);
    $navigator.off("keypress:left", switchToLeftOption);
    isRegKeyListeners.value = false;
}
const onFocus = (): void => {
    registerKeyListeners();
}
const onBlur = (): void => {
    unregisterKeyListeners();
}
const focusOnSwitch = inject<FocusOnSwitch>('focusOnSwitch');

onMounted(() => {
    focusOnSwitch?.(switchRef);
})
</script>

<style lang="scss">
    @import url("styles.scss");
</style>